import styled, { css } from 'foundations-theming/utils';
export const LogoPlaceholder = styled.div.withConfig({
  displayName: "LogoPlaceholder"
})(["", ""], ({
  theme,
  isMobile
}) => {
  const size = isMobile ? '32px' : '44px';
  return css(["width:", ";height:", ";border-radius:", ";background-color:", ";"], size, size, theme.borderRadius['full'], theme.color['border-core-default']);
});